import React from 'react';
import { motion } from 'framer-motion';

const stats = [
  { value: 80, label: 'of corporate volunteering time is admin work' },
  { value: 73, label: 'of CSR plans never get executed' },
  { value: 90, label: 'reduction in coordination time with CORAA' },
];

const WhyItMatters = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-gray-900 to-black relative overflow-hidden">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-5xl font-bold mb-4">
            <span className="text-green-400">The Work No One Sees </span>
            <span className="text-red-400">But Everyone Pays For</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Every campaign looks simple on the outside  <br />
            <span className="text-white font-semibold">but behind the scenes…</span>
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }} className="flex items-center gap-4 bg-gray-800/50 border border-green-500/10 rounded-xl px-6 py-5">
            <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-[#222b3a] border border-green-400/30">
              {/* Envelope SVG */}
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="28" height="28" rx="8" fill="#222b3a" />
                <path d="M6 9.5V19a2 2 0 002 2h12a2 2 0 002-2V9.5l-8 5-8-5z" stroke="#3FA65B" strokeWidth="1.7" strokeLinejoin="round"/>
                <path d="M6 9.5l8 5 8-5" stroke="#3FA65B" strokeWidth="1.7" strokeLinejoin="round"/>
              </svg>
            </span>
            <span className="text-white/90 font-medium">17+ emails just to finalize one date</span>
          </motion.div>
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.1 }} className="flex items-center gap-4 bg-gray-800/50 border border-green-500/10 rounded-xl px-6 py-5">
            <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-[#222b3a] border border-green-400/30">
              {/* Folder SVG */}
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="28" height="28" rx="8" fill="#222b3a" />
                <path d="M6 10a2 2 0 012-2h3l2 2h7a2 2 0 012 2v8a2 2 0 01-2 2H8a2 2 0 01-2-2v-8z" stroke="#3FA65B" strokeWidth="1.7" strokeLinejoin="round"/>
              </svg>
            </span>
            <span className="text-white/90 font-medium">3 decks all named final_final_v4.pptx</span>
          </motion.div>
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.2 }} className="flex items-center gap-4 bg-gray-800/50 border border-green-500/10 rounded-xl px-6 py-5">
            <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-[#222b3a] border border-green-400/30">
              {/* Phone SVG */}
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="28" height="28" rx="8" fill="#222b3a" />
                <path d="M8.5 7.5l3 3a1 1 0 010 1.4l-1.3 1.3a12.5 12.5 0 005.6 5.6l1.3-1.3a1 1 0 011.4 0l3 3a1 1 0 010 1.4l-1.1 1.1c-.7.7-1.8.8-2.6.3-2.8-1.5-5.2-3.9-6.7-6.7-.5-.8-.4-1.9.3-2.6l1.1-1.1a1 1 0 011.4 0z" stroke="#3FA65B" strokeWidth="1.7" strokeLinejoin="round"/>
              </svg>
            </span>
            <span className="text-white/90 font-medium">4 follow-up calls for NGO confirmations</span>
          </motion.div>
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.3 }} className="flex items-center gap-4 bg-gray-800/50 border border-green-500/10 rounded-xl px-6 py-5">
            <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-[#222b3a] border border-green-400/30">
              {/* Clock SVG */}
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="28" height="28" rx="8" fill="#222b3a" />
                <circle cx="14" cy="14" r="8" stroke="#3FA65B" strokeWidth="1.7"/>
                <path d="M14 10v4l3 3" stroke="#3FA65B" strokeWidth="1.7" strokeLinecap="round"/>
              </svg>
            </span>
            <span className="text-white/90 font-medium">2 weeks to collect feedback</span>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }} className="bg-gray-900/70 border border-green-500/20 rounded-xl px-6 py-6 text-center">
            <div className="text-2xl md:text-3xl font-semibold text-green-300 mb-2 flex items-center justify-center gap-2">
              12–18h
            </div>
            <div className="text-gray-300 text-base">admin per campaign</div>
          </motion.div>
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.1 }} className="bg-gray-900/70 border border-green-500/20 rounded-xl px-6 py-6 text-center">
            <div className="text-2xl md:text-3xl font-semibold text-green-300 mb-2 flex items-center justify-center gap-2">
              $450–$800
            </div>
            <div className="text-gray-300 text-base">in salaried time, per event</div>
          </motion.div>
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.2 }} className="bg-gray-900/70 border border-green-500/20 rounded-xl px-6 py-6 text-center">
            <div className="text-2xl md:text-3xl font-semibold text-green-300 mb-2 flex items-center justify-center gap-2">
              <svg className="w-7 h-7 text-green-400 inline-block" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="#3FA65B" strokeWidth="2"/><path d="M12 8v4l3 3" stroke="#3FA65B" strokeWidth="2" strokeLinecap="round"/></svg>
              60%
            </div>
            <div className="text-gray-300 text-base">reporting takes longer than execution</div>
          </motion.div>
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.3 }} className="bg-gray-900/70 border border-green-500/20 rounded-xl px-6 py-6 text-center">
            <div className="text-2xl md:text-3xl font-semibold text-green-300 mb-2 flex items-center justify-center gap-2">
              3+ hrs/week
            </div>
            <div className="text-gray-300 text-base">spent on manual reporting & admin</div>
          </motion.div>
        </div>

        {/* Icons and extra explanations removed for a cleaner look */}
        

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6, duration: 0.6 }}
          className="mt-20 max-w-4xl mx-auto bg-gradient-to-r from-green-500/10 to-blue-500/10 p-8 rounded-2xl border border-green-500/20 text-center"
        >
          <h3 className="text-2xl md:text-3xl font-bold mb-4 text-red-400">
             No one budgets for it. No one reports it. But every impact team pays for it.
          </h3>
          <p className="text-gray-300">
            The real cost of impact work is invisible, until you add it up.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6, duration: 0.6 }}
        >
        </motion.div>
      </div>
    </section>
  );
};

// Helper component for animated counter
const AnimatedCounter = ({ value }: { value: number }) => {
  const [count, setCount] = React.useState(0);

  React.useEffect(() => {
    // If value is 0, set count to 0 immediately
    if (value === 0) {
      setCount(0);
      return;
    }

    const duration = 2000; // Animation duration in ms
    const stepTime = Math.max(Math.floor(duration / value), 30); // Calculate step time
    
    let current = 0;
    const timer = setInterval(() => {
      current += 1;
      setCount(current);
      if (current >= value) {
        clearInterval(timer);
      }
    }, stepTime);

    return () => clearInterval(timer);
  }, [value]);

  return <>{count}</>;
};

export default WhyItMatters;
